import { provideHttpClient } from '@angular/common/http';
import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { environment } from '@env/environment';

import { provideSvgIcons } from '@ngneat/svg-icon';
import { provideServices } from '@services/index';

import { AppComponent } from './app/app.component';
import { APP_ROUTES } from './app/app.routes';
import { icons } from './app/svg/icons';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(BrowserModule),
    provideSvgIcons(icons),
    provideRouter(APP_ROUTES),
    provideHttpClient(),
    provideServices(),
  ],
}).catch(err => console.error(err));
